import React, { useRef } from "react";
import * as THREE from "three";

// Enhanced Basketball Trail Component
export const BasketballTrail = ({ points, color = "#FF8C00" }) => {
	const lineRef = useRef();

	React.useEffect(() => {
		if (lineRef.current && points.length > 1) {
			const geometry = lineRef.current.geometry;
			if (geometry) {
				geometry.setFromPoints(
					points.map((p) => new THREE.Vector3(p[0], p[1], p[2])),
				);
			}
		}
	}, [points]);

	if (points.length < 2) return null;

	return (
		<line ref={lineRef}>
			<bufferGeometry />
			<lineBasicMaterial
				color={color}
				transparent
				opacity={0.7}
				linewidth={3}
			/>
		</line>
	);
};
